import { Check, X, AlertTriangle } from "lucide-react";
import { fmt } from "../lib/format";

export const PendingPanel = ({ pending, onConfirm, onReject }) => {
  if (!pending?.length) return null;
  return (
    <div className="fixed bottom-3 left-3 z-50 flex flex-col gap-2 w-[340px] max-h-[70vh] overflow-auto thin-scroll">
      {pending.map((p) => {
        const long = p.direction === "LONG";
        return (
          <div
            key={p.id}
            data-testid={`pending-${p.id}`}
            className="border border-red-500/40 bg-[#0c0a0a] rounded-sm shadow-lg shadow-red-900/20"
          >
            <div className="flex items-center gap-2 px-3 py-1.5 border-b border-red-500/30 bg-red-500/10">
              <AlertTriangle size={13} className="text-red-400" />
              <span className="text-[10px] font-bold uppercase tracking-wider text-red-400">
                Live Order — Confirm
              </span>
            </div>
            <div className="px-3 py-2">
              <div className="flex items-center gap-2">
                <span className={`px-1.5 py-0.5 text-[10px] font-bold rounded-sm ${long ? "text-green-500 bg-green-500/10" : "text-red-500 bg-red-500/10"}`}>
                  {p.direction}
                </span>
                <span className="font-mono text-sm font-bold text-zinc-100">{p.symbol}</span>
                <span className="font-mono text-[11px] text-zinc-400">×{p.qty} @ {fmt(p.price)}</span>
                <span className="ml-auto font-mono text-[11px] font-bold text-blue-400">{p.score}/{p.threshold}</span>
              </div>
              <div className="flex gap-3 mt-1.5 font-mono text-[10px] text-zinc-500">
                <span>SL <span className="text-red-500">{fmt(p.stop_loss)}</span></span>
                <span>TP <span className="text-blue-400">{fmt(p.take_profit)}</span></span>
              </div>
              <div className="flex gap-2 mt-2">
                <button
                  data-testid={`confirm-${p.id}`}
                  onClick={() => onConfirm(p.id)}
                  className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 text-[11px] font-bold rounded-sm bg-green-600 text-white hover:bg-green-500 transition-colors duration-150"
                >
                  <Check size={13} /> CONFIRM
                </button>
                <button
                  data-testid={`reject-${p.id}`}
                  onClick={() => onReject(p.id)}
                  className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 text-[11px] font-bold rounded-sm bg-zinc-800 text-zinc-300 hover:bg-zinc-700 transition-colors duration-150"
                >
                  <X size={13} /> REJECT
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
